import type { IconProps } from '../types';

const Spinner = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M6.98 0h2.04v4.28H6.98V0ZM16 6.98v2.04h-4.28V6.98H16Zm-1.62 5.96-1.44 1.44-3.03-3.03 1.44-1.44 3.03 3.03ZM9.02 16H6.98v-4.28h2.04V16Zm-5.96-1.62-1.44-1.44L4.65 9.9l1.44 1.44-3.03 3.03ZM0 9.02V6.98h4.28v2.04H0Zm1.62-5.96 1.44-1.44L6.1 4.65 4.65 6.1 1.62 3.06Z" />
  </svg>
);

export default Spinner;
